import { render, staticRenderFns } from "./choice-route.vue?vue&type=template&id=211f5cf2&scoped=true&"
import script from "./choice-route.vue?vue&type=script&lang=js&"
export * from "./choice-route.vue?vue&type=script&lang=js&"
import style0 from "./choice-route.vue?vue&type=style&index=0&id=211f5cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f5cf2",
  null
  
)

export default component.exports